<template>
  <div class="indexswiper">
    <v-headtitle
      v-if="transparent_head"
      :login_status="login_status"
      :cart="cart"
      indexmodule="indexmodule"
      :title="title"
      :hasheader="hasheader?toptitleheight:''"
      :checkout_member_config="checkout_member_config"
      :secondary_menu="secondary_menu"
      :mainmenu="mainmenu"
      :pixel="pixel"
      :cart_type="cart_type"
      :title_logo="title_logo"
      :pixel_conversion="pixel_conversion"
    ></v-headtitle>
    <swiper class="swiper" :options="swiperOption" ref="mySwiper">
      <swiper-slide
        v-for="(item,index) in carousel.items"
        style="text-align:center"
        :class=" carousel.items.length==1? 'swiper-no-swiping':''"
        :key="index"
      >
        <div class="overlay"  v-if="item.show_overlay" :style="'opacity:'+item.opacity/100"></div>
        <img
          v-if="item.image&&item.image.srcset&&item.image.url"
          data-sizes="auto"
          :data-srcset="item.image.srcset+','+item.image.url+' 1000w'"
          class="swiper-lazy lazyload"
          @error.once="imageFailure($event,defaultBanner)"
          @mousemove.prevent
          :data-index="index"
          @load="carousel.slide_height&&carousel.slide_height=='adaptfirst'&&index==0&&imgLoad()"
          alt
        />
        <img
          v-else-if="item.image&&typeof(item.image)=='string'"
          :data-index="index"
          @load="carousel.slide_height&&carousel.slide_height=='adaptfirst'&&index==0&&imgLoad()"
          data-sizes="auto"
          :data-srcset="item.image"
          class="swiper-lazy lazyload"
          @error.once="imageFailure($event,defaultBanner)"
          @mousemove.prevent
          alt
        />
        <img
          v-else
          data-sizes="auto"
          :data-index="index"
          @load="carousel.slide_height&&carousel.slide_height=='adaptfirst'&&index==0&&imgLoad()"
          :data-srcset="defaultBanner"
          class="swiper-lazy lazyload"
          @error.once="imageFailure($event,defaultBanner)"
          @mousemove.prevent
          alt
        />
        <v-indexswiperbtnbox
          v-show="carousel.slide_height!='adaptfirst'||window_innerWidth"
          :title="item.title"
          :description="item.description"
          :button="item.button"
          :align="item.align"
          :button_background_color="item.button_background_color"
          :button_text_color="item.button_text_color"
          :text_color="item.text_color"
          :title_font_size="title_font_size"
          :title_font_family="title_font_family"
        ></v-indexswiperbtnbox>
      </swiper-slide>
      <div class="navigationbox container" v-if="carousel.items.length>1">
        <i class="iconfont icon-web__bitebizuojiantou prev"></i>
        <i class="iconfont icon-web__bitebiyoujiantou next"></i>
        <div class="swiper-pagination" >
          <span class="my-bullet" v-for="(item,index) in carousel.items" :key="index" @click="swiper.slideTo(index+1)"></span>
        </div>
      </div>
    </swiper>
    <v-indexswiperbtnbox
          v-if="carousel.slide_height=='adaptfirst'&&!window_innerWidth"
          slide_height="adaptfirst"
          :title="swiper_title"
          :description="swiper_description"
          :button="swiper_button"
          align="center"
          text_color="black"
          :title_font_size="title_font_size"
          :title_font_family="title_font_family"
    ></v-indexswiperbtnbox>
  </div>
</template>
<script>
import defaultBanner from "../../../../../public/images/defaultBanner.jpg";
export default {
  props: [
    "cart",
    "title",
    "carousel",
    "login_status",
    "hasheader",
    "checkout_member_config",
    "mainmenu",
    "secondary_menu",
    "pixel",
    "cart_type",
    "title_font_size",
    "title_font_family",
    "title_logo",
    "pixel_conversion",
    "transparent_head"
  ],
  data() {
    return {
      swiperOption: {
        effect: "fade", //淡入淡出
        loop: this.carousel.items.length > 1, //无限滑动
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        //   bulletClass: "my-bullet",
        //   bulletActiveClass: "my-bullet-active"
        // },
        navigation: {
          nextEl: ".next",
          prevEl: ".prev"
        },
        noSwiping: true,
        lazy: {
          loadPrevNext: false
        },
        autoplay:
          this.carousel.interval && this.carousel.items.length > 1
            ? { delay: this.carousel.interval * 1000 }
            : false,
        on: {
          // paginationRender:()=>{
          //   if(!this.count){
          //   let color=this.$('.swiper-slide-active .indexswiperbtnbox p').css('color');
          //   this.$('.swiper-pagination .my-bullet').css({'border-color':color,'background':'transparent'});
          //   this.$('.swiper-pagination .my-bullet:first').css('background-color',color);
          //   this.$('.navigationbox i').css('color',color);
          //   }
          // },
          slideChangeTransitionStart:()=>{
            // let color=this.$('.swiper-slide-active .indexswiperbtnbox p').css('color');
            this.$('.swiper-pagination .my-bullet').css({'background':'transparent'});
            let color="#fff";
            if(this.swiper){
              this.activeIndex= this.swiper.activeIndex-1;
              if(this.activeIndex>this.carousel.items.length-1){
                  this.activeIndex=0;
              }else if(this.activeIndex<0){
                this.activeIndex=this.carousel.items.length-1;
              }
              color=this.carousel.items[this.activeIndex].text_color||'#fff';
              this.$(this.$('.swiper-pagination span')[this.activeIndex]).css({'background':color});
              this.count=true;
            }else{
              color=this.carousel.items[0].text_color||'#fff';
              this.$('.swiper-pagination span:first').css({'background':color});
            }
            this.$('.swiper-pagination .my-bullet').css({'border-color':color});
            this.$('.navigationbox i').css('color',color);
            console.log(this.window_innerWidth);
            if(this.window_innerWidth){
              this.$('.swiper-wrapper .swiper-slide-active .indexswiperbtnbox').show();
            }else{
              this.$('.swiper-wrapper .swiper-slide-active .indexswiperbtnbox').hide();
            }
            this.swiper_adaptfirst(this.activeIndex);
            // this.swiper_title=this.carousel.items[this.activeIndex].title;
            // this.swiper_description=this.carousel.items[this.activeIndex].description;
            // this.swiper_button=this.carousel.items[this.activeIndex].button;
          }
        },    
      },
      headboxheight:0,
      toptitleheight: 0,
      defaultBanner,
      window_innerWidth:false,
      swiper_title:null,
      swiper_description:null,
      swiper_button:{},
      activeIndex:0,
    };
  },
  methods: {
    swiper_adaptfirst(index){
        if(this.carousel.items[index]){
          this.swiper_title=this.carousel.items[index].title;
          this.swiper_description=this.carousel.items[index].description;
          this.swiper_button=this.carousel.items[index].button;
        }
    },
    imgLoad(){
      if(window.innerWidth>=769){
          this.window_innerWidth=true;
      }else{
          this.window_innerWidth=false;
      }
      this.$('.indexswiper .swiper [data-index = 0]').css({height:"auto"})
      this.$(".indexswiper .swiper-wrapper img").height(this.$('.indexswiper .swiper [data-index = 0]')[0].clientHeight);
    },
    resetswiperheight() {
      this.headboxheight=this.$("#app>.headbox").outerHeight();
      let height= isNaN(this.headboxheight)?0:this.headboxheight;
      height=isNaN(this.toptitleheight)?height:height+this.toptitleheight;
      this.$(".indexswiper").height(
        this.$(window).height() - height
      );
    }
  },
  beforeMount(){
    if(window.innerWidth>=769){
        this.window_innerWidth=true;
    }else{
        this.window_innerWidth=false;
    }
    this.swiper_adaptfirst(0);
  },
  mounted() {
    console.log('transparent_head',this.transparent_head);
    console.log("carousel", this.carousel);
    console.log("title_font", this.title_font);
    this.toptitleheight = this.$(".toptitle").outerHeight();
    if (this.carousel.slide_height!='adaptfirst') {
      this.resetswiperheight();
      window.onresize = () => {
        this.resetswiperheight();
      };
    }else if(this.carousel.slide_height=='adaptfirst') {
      if(!this.window_innerWidth){
        console.log(this.$('.index_wrap'));
        this.$('.index_wrap').css('padding-top','45px');
      }
      window.onresize = () => {
        this.imgLoad()
      };
    }
  },
  computed: {
    //获取swiper实例
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  }
};
</script>
<style   lang='scss'>
.indexswiper {
  position: relative;
  width: 100%;
  .swiper {
    position: relative;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: black;
    }
    .swiper-pagination {
      display: inline-block;
      text-align: center;
      left: 0;
      right: 0;
      width: fit-content;
      width: -webkit-fit-content;
      width: -moz-fit-content;
      margin: 0 auto;
      z-index: 10;
      .my-bullet {
        cursor: pointer;
        display: inline-block;
        margin: 0 5px;
        width: 8px;
        height: 8px;
        border: 2px solid white;
        border-radius: 100%;
      }
      .my-bullet-active {
        background: white;
      }
    }
  }
  .navigationbox {
    position: absolute;
    z-index: 1;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    i {
      color: white;
      font-style: normal;
      font-size: 15px;
      cursor: pointer !important;
    }
    .prev {
      float: left;
    }
    .next {
      float: right;
    }
  }
}
</style>